// extracted by mini-css-extract-plugin
export default {"container":"PuzzleItem_container__Wu91l","grabbing":"PuzzleItem_grabbing__6f9rm","picture":"PuzzleItem_picture__HHgNB","letter":"PuzzleItem_letter__XfDlX"};